import { http } from 'http';

export default {
  operationByIdB2C: operationId => http.get(`/operations/${operationId}`),
  operationByIdB2B: operationId => http.get(`/operations/${operationId}`),
  getRisks: url => http.get(url)
};
